import moment from 'moment';

/**
 * Gives a text representation of the notification time, relative to the current Date.
 *
 * The current date is received as a parameter to make this a pure function so it's easier to test.
 *
 * @param {Number} timestamp the timestamp of the notification
 * @param {String|Date|moment.Moment} currentDate the current date to compare with the timestamp, can be a string, a `Date` object or a `moment()` instance
 * @param {String} currentDateFormat format used to parse currentDate when its passed as a String, defaults to "YYYMMDD"
 *
 * @returns String
 */
const getTimestampAsText = (timestamp, currentDate, currentDateFormat = 'YYYYMMDD') => {
  if (!timestamp) {
    return '';
  }

  const date = moment(timestamp);

  const current = moment(currentDate, currentDateFormat);

  if (date.isSame(current, 'day')) {
    return date.format('LT');
  }

  const yesterday = current.subtract(1, 'day');

  if (date.isSame(yesterday, 'day')) {
    // This is a little hacky, but it automatically translates 'Yesterday'
    return date
      .calendar(currentDate)
      .replace(/\d+:\d+/, '')
      .split(/\s+/)
      .sort((a, b) => b.length - a.length)[0];
  }

  return date.format('MMM D');
};

export default getTimestampAsText;
